/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_ReactivateInputs */

const cs_franchise_reactivate = /** @type {(inputs: Franchise_ReactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit licenci`)
};

const en_franchise_reactivate = /** @type {(inputs: Franchise_ReactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reactivate license`)
};

/**
* | output |
* | --- |
* | "Reactivate license" |
*
* @param {Franchise_ReactivateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_reactivate = /** @type {((inputs?: Franchise_ReactivateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_ReactivateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_reactivate(inputs)
	return cs_franchise_reactivate(inputs)
});